/*
 *   File : app.js
 *   Author : https://evoqins.com
 *   Description : app component handles routes
 *   Integrations : NA
 *   Version : 1.0.0
 */

import React from "react";
import { ProtectedRoute } from "./Components/Other";
import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
// import { useEffect, useState } from "react";
// import Cookies from "js-cookie";
import "./Style/global.scss";
import { ForgotPassword, Login } from "./Container/Auth";
import { AuthLayout, MainLayout } from "./Components/Other";
import { Dashboard } from './Container/Dashboard'
import { ManageSubAdmin, ManageSubAdminDetail, UpsertAdmin, UpsertRoles } from "./Container/ManageSubAdmin";
import { UserDetail, Users } from "./Container/Users";
import { OrderDetail, Orders } from "./Container/Orders";
import { ManageRiskScore, UpsertQuestion } from "./Container/ManageRiskScore";
import { AddGoal, GoalDetail, ManageGoal } from "./Container/ManageGoal";
import { AddBasket, ManageBasket, ManageDetail } from "./Container/ManageBasket";
import { ManageStory, UpsertStory } from "./Container/ManageStory";
import { ManageContent } from "./Container/ManageContent";
import { AddNotification, UpsertDisclosure, UpsertFaq, UpsertPrivacyPolicy, UpsertTermsAndCondition } from "./Container/ManageContent/Helper";
// import { GoalRebalanceHistory } from "./Container/ManageGoal/Helper";
import { BasketRebalanceHistory } from "./Container/ManageBasket/Helper";
import { ToastContainer } from "react-toastify";
import { AllNotification } from "./Container/Notification";
import { MfdManagementDetail, MfdManagementList } from "./Container/MfdManagement";
import { RevenueAndReportList } from "./Container/RevenueAndReport";

function App() {

  return (
    <Router>
      <Routes>
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
        </Route>
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Dashboard />} />

          <Route path="/notifications" element={<AllNotification />} />

          <Route path="/manage-sub-admin" element={<ManageSubAdmin />} />
          <Route path="/manage-sub-admin/detail/:id" element={<ManageSubAdminDetail />} />
          <Route path="/manage-sub-admin/edit/:id" element={<UpsertAdmin />} />
          <Route path="/manage-sub-admin/add" element={<UpsertAdmin />} />
          <Route path="/manage-sub-admin/roles/add" element={<UpsertRoles />} />
          <Route path="/manage-sub-admin/roles/edit/:id" element={<UpsertRoles />} />

          <Route path="/users" element={<Users />} />
          <Route path="/users/:type" element={<Users />} />
          <Route path="/users/detail/:id" element={<UserDetail />} />

          <Route path="/orders" element={<Orders />} />
          <Route path="/orders/detail/:type/:id" element={<OrderDetail />} />

          <Route path="/mfd-management" >
            <Route index element={<MfdManagementList />} />
            <Route path=":id" element={<MfdManagementDetail />} />
          </Route>

          <Route path="/revenue-payouts" element={<RevenueAndReportList />} />

          <Route path="/manage-risk-score" element={<ManageRiskScore />} />
          <Route path="/manage-risk-score/risk" element={<ManageRiskScore />} />
          <Route path="/manage-risk-score/risk/edit" element={<ManageRiskScore />} />
          <Route path="/manage-risk-score/add" element={<UpsertQuestion />} />
          <Route path="/manage-risk-score/edit/:q_id" element={<UpsertQuestion />} />


          <Route path="/manage-goal" element={<ManageGoal />} />
          <Route path="/manage-goal/add" element={<AddGoal />} />
          <Route path="/manage-goal/detail/:id" element={<GoalDetail />} />
          {/* <Route path="/manage-goal/detail/:id/rebalance-history" element={<GoalRebalanceHistory />} /> */}

          <Route path="/manage-basket" element={<ManageBasket />} />
          <Route path="/manage-basket/add" element={<AddBasket />} />
          <Route path="/manage-basket/detail/:id" element={<ManageDetail />} />
          <Route path="/manage-basket/detail/:id/rebalance-history" element={<BasketRebalanceHistory />} />

          <Route path="/manage-story" element={<ManageStory />} />
          <Route path="/manage-story/edit/:id" element={<UpsertStory />} />
          <Route path="/manage-story/add" element={<UpsertStory />} />

          <Route path="/manage-content" element={<ManageContent />} />
          <Route path="/manage-content/notification" element={<ManageContent />} />
          <Route path="/manage-content/notification/add" element={<AddNotification />} />

          <Route path="/manage-content/faq" element={<ManageContent />} />
          <Route path="/manage-content/faq/add" element={<UpsertFaq />} />
          <Route path="/manage-content/faq/edit/:id" element={<UpsertFaq />} />

          <Route path="/manage-content/terms-conditions" element={<ManageContent />} />
          <Route path="/manage-content/terms-conditions/edit" element={<UpsertTermsAndCondition />} />

          <Route path="/manage-content/privacy-policy" element={<ManageContent />} />
          <Route path="/manage-content/privacy-policy/edit" element={<UpsertPrivacyPolicy />} />

          <Route path="/manage-content/disclosure" element={<ManageContent />} />
          <Route path="/manage-content/disclosure/edit" element={<UpsertDisclosure />} />

        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer
        className={'toastify-toast'}
        autoClose={3000}
        pauseOnHover={false}
        position="bottom-right"
      />
    </Router>
  );
}

export default App